import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import axiosInstance from '../../../services/axiosInstance';

const OutlookCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('processing');
    const [error, setError] = useState('');

    const processed = React.useRef(false);

    useEffect(() => {
        const code = searchParams.get('code');

        if (code) {
            if (processed.current) return;
            processed.current = true;
            connectOutlook(code);
        } else {
            setStatus('error');
            setError('No authorization code found');
        }
    }, [searchParams]);

    const connectOutlook = async (code) => {
        try {
            const userId = localStorage.getItem("userId");

            if (!userId) {
                setStatus('error');
                setError('User not logged in. Please login first.');
                return;
            }

            await axiosInstance.post('/outlook-calendar/connect', {
                code,
                userId
            });
            setStatus('success');
            setTimeout(() => {
                navigate('/appointment-booking');
            }, 2000);
        } catch (err) {
            console.error(err);
            setStatus('error');
            setError('Failed to connect Outlook Calendar. ' + (err.response?.data?.message || err.message));
        }
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh" bgcolor="#f8f9fa">
            <Box p={4} bgcolor="white" borderRadius={4} boxShadow="0 10px 40px rgba(0,0,0,0.05)" textAlign="center" maxWidth={400}>
                {status === 'processing' && (
                    <>
                        <CircularProgress size={60} thickness={5} sx={{ color: '#0078d4' }} />
                        <Typography variant="h6" fontWeight={700} mt={3} color="#333">
                            Verifying with Microsoft...
                        </Typography>
                        <Typography variant="body2" color="text.secondary" mt={1}>
                            Please wait while we secure your connection to Outlook.
                        </Typography>
                    </>
                )}

                {status === 'success' && (
                    <Box>
                        <Alert
                            severity="success"
                            variant="filled"
                            sx={{ borderRadius: 3, fontWeight: 600, px: 3, py: 2 }}
                        >
                            Sync Successful!
                        </Alert>
                        <Typography variant="body2" color="text.secondary" mt={2}>
                            Redirecting you back to settings...
                        </Typography>
                    </Box>
                )}

                {status === 'error' && (
                    <Box>
                        <Alert
                            severity="error"
                            variant="filled"
                            sx={{ borderRadius: 3, fontWeight: 600, px: 3, py: 2 }}
                        >
                            {error}
                        </Alert>
                        <Typography
                            variant="body2"
                            color="#0060b0"
                            mt={2}
                            sx={{ cursor: 'pointer', fontWeight: 600 }}
                            onClick={() => navigate('/user/schedule-settings')}
                        >
                            Go back to settings
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default OutlookCallback;
